import gql from 'graphql-tag';

export const typeDefs = gql`
    extend type Query {
        isLoggedIn: Boolean!
        activeNav: String!
        activeMenu: String!
    }
`;
export const resolvers = {};